import {
  AddComment,
  ChatBubble,
  ChatBubbleOutline,
  CheckCircleOutline,
  ErrorOutline,
} from "@mui/icons-material";
import {
  Avatar,
  Box,
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Fab,
  Fade,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  MenuItem,
  Pagination,
  Paper,
  Select,
  Tooltip,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const CreateNewChatSession = () => {
  const [chatHistory, setChatSessions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [withinTime, setWithinTime] = useState(false);
  const [selectedTicketId, setSelectedTicketId] = useState("");
  const [ticketList, setticketList] = useState([]);
  const checkChatAvailability = () => {
    const now = new Date();
    const start = new Date();
    const end = new Date();

    start.setHours(10, 30, 0); // 10:30 AM
    end.setHours(18, 30, 0); // 6:30 PM

    const isAvailable = now >= start && now <= end;
    setWithinTime(isAvailable);
    setOpenModal(true);
  };

  const pageSize = 5;

  const fetchChatHistory = async (currPage) => {
    setLoading(true);
    try {
      const userId = sessionStorage.getItem("userId");
      const response = await axios.get(
        `https://apisupport.ipaisa.co.in/supportapp/chatsession/user/${userId}?page=${currPage - 1}&size=${pageSize}`
      );
      setChatSessions(response.data.content);
      setTotalPages(response.data.totalPages);
    } catch (e) {
      console.log(e);
    }
  };

  const fetchTickets = async () => {
    try {
      const userId = sessionStorage.getItem("userId");

      if (!userId) {
        throw new Error("User ID not found in sessionStorage");
      }

      const response = await axios.get(
        "https://apisupport.ipaisa.co.in/supportapp/auth/ticket/getbyuser",
        {
          headers: {
            userid: userId,
          },
        }
      );

      setticketList(response.data);
      console.log("Fetched tickets:", response.data);
    } catch (error) {
      console.error("Error fetching tickets:", error.message);
    }
  };

  const handleGoToChat = () => {
    const userId = sessionStorage.getItem("userId");
    let ticketId = selectedTicketId;
    if (!ticketId) {
      const timestamp = new Date()
        .toISOString()
        .replace(/[-T:\.Z]/g, "")
        .slice(0, 14);
      ticketId = `CHATSESSION-${userId}-${timestamp}`;
    }

    navigate(`/ticketdetail/${ticketId}`);
  };

  useEffect(() => {
    setPage(1);
    fetchChatHistory(1);
    fetchTickets();
  }, []);
  return (
    <div>
      <Container
        maxWidth="xl"
        sx={{ padding: "2rem", marginTop: "calc(3% + 56px)" }}
      >
        <Typography
          sx={{
            fontWeight: "bold",
            fontFamily: "sans-serif",
            fontSize: "1.25rem",
            color: "#343C6A",
          }}
        >
          💬 Chat Section
        </Typography>

        {/* Centered New Chat Box */}
        {/* Stylish Banner Header */}
        <Box
          sx={{
            width: "100%",
            borderRadius: 3,
            p: 3,
            mb: 4,
            background: "linear-gradient(135deg, #e3f2fd, #ffffff)",
            boxShadow: "0 6px 16px rgba(0,0,0,0.05)",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          <Box display="flex" alignItems="center" gap={2}>
            <Avatar sx={{ bgcolor: "#1976d2", width: 48, height: 48 }}>
              <ChatBubbleOutline />
            </Avatar>
            <Box>
              <Typography variant="h5" fontWeight="bold" color="#343C6A">
                Chat Support Center
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Need help? Start a chat with our support team.
              </Typography>
            </Box>
          </Box>

          <Button
            onClick={checkChatAvailability}
            variant="contained"
            color="primary"
            size="medium"
            sx={{
              mt: { xs: 2, sm: 0 },
              px: 4,
              py: 1,
              fontWeight: "bold",
              boxShadow: "0 3px 6px rgba(0,0,0,0.15)",
              borderRadius: 2,
              textTransform: "none",
            }}
          >
            Create Chat
          </Button>
        </Box>

        {/* Floating Action Button for New Chat */}
        {/* <Box position="fixed" bottom={24} right={24} zIndex={1000}>
          <Tooltip title="Chat with Support">
            <Fab
              color="primary"
              onClick={checkChatAvailability}
              sx={{
                boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                transition: "all 0.3s",
                ":hover": {
                  transform: "scale(1.1)",
                },
              }}
            >
              <AddComment />
            </Fab>
          </Tooltip>
        </Box> */}

        {/* Chat History Section */}
        <Box mt={4} maxWidth={800} mx="auto">
          <Typography variant="h6" mb={2} fontWeight="bold">
            Your Previous Chat Sessions
          </Typography>
          <Paper
            elevation={4}
            sx={{ borderRadius: 4, backgroundColor: "#fafafa", p: 2 }}
          >
            {chatHistory.length === 0 ? (
              <Typography color="text.secondary" textAlign="center" py={4}>
                You haven’t started any chat sessions yet.
              </Typography>
            ) : (
              <List>
                {chatHistory.map((chat, index) => (
                  <Fade in={true} timeout={500} key={chat.id}>
                    <Box>
                      <ListItem alignItems="flex-start">
                        <Box width="100%">
                          <Box
                            display="flex"
                            flexDirection={{ xs: "column", sm: "row" }}
                            justifyContent="space-between"
                            alignItems={{ xs: "flex-start", sm: "center" }}
                            gap={2}
                            flexWrap="wrap"
                          >
                            <Box display="flex" alignItems="center" gap={1}>
                              <ListItemAvatar>
                                <Avatar
                                  sx={{
                                    bgcolor: chat.active
                                      ? "#4caf50"
                                      : "grey.400",
                                  }}
                                >
                                  {chat.active ? (
                                    <ChatBubbleOutline />
                                  ) : (
                                    <ChatBubble />
                                  )}
                                </Avatar>
                              </ListItemAvatar>
                              <ListItemText
                                primary={
                                  <Typography
                                    variant="subtitle1"
                                    fontWeight="bold"
                                  >
                                    Chat Id/TicketId: {chat.ticketId}
                                  </Typography>
                                }
                                secondary={`Status: ${chat.active ? "Active ✅" : "Closed ❌"}`}
                              />
                            </Box>
                            <Box
                              display="flex"
                              flexDirection={{ sm: "row" }}
                              gap={1}
                            >
                              <Button
                                variant="contained"
                                sx={{
                                  backgroundColor: chat.active
                                    ? "#4caf50"
                                    : "#9e9e9e",
                                  ":hover": {
                                    backgroundColor: chat.active
                                      ? "#45a049"
                                      : "#bdbdbd",
                                  },
                                }}
                                disabled={!chat.active}
                                onClick={() =>
                                  navigate(`/ticketdetail/${chat.ticketId}`)
                                }
                                size="small"
                              >
                                {chat.active ? "Go to Chat" : "Closed"}
                              </Button>
                              <Button
                                size="small"
                                variant="outlined"
                                color="info"
                                onClick={() =>
                                  navigate(`/ticketdetail/${chat.ticketId}`)
                                }
                              >
                                See Chats
                              </Button>
                            </Box>
                          </Box>
                        </Box>
                      </ListItem>
                      {index !== chatHistory.length - 1 && <Divider />}
                    </Box>
                  </Fade>
                ))}
              </List>
            )}

            {/* Pagination */}
            {totalPages > 1 && (
              <Box display="flex" justifyContent="center" mt={2}>
                <Pagination
                  count={totalPages}
                  page={page}
                  onChange={(e, value) => {
                    setPage(value);
                    fetchChatHistory(value);
                  }}
                  color="primary"
                />
              </Box>
            )}
          </Paper>
        </Box>

        {/* Modal */}
        <Dialog
          open={openModal}
          onClose={() => setOpenModal(false)}
          PaperProps={{
            sx: {
              borderRadius: 4,
              p: 2,
              background: "linear-gradient(135deg, #ffffff, #e3f2fd)",
              boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
            },
          }}
        >
          <DialogTitle sx={{ fontWeight: "bold", color: "#1976d2" }}>
            <Box display="flex" alignItems="center" gap={1}>
              <ChatBubbleOutline color="primary" />
              Chat Service Availability
            </Box>
          </DialogTitle>

          <DialogContent>
            <Typography sx={{ mb: 1 }}>
              Our support chat is available from{" "}
              <strong>10:30 AM to 6:30 PM</strong>.
            </Typography>
            <Box display="flex" alignItems="center" gap={1}>
              {withinTime ? (
                <>
                  <Avatar sx={{ bgcolor: "#4caf50", width: 28, height: 28 }}>
                    <CheckCircleOutline fontSize="small" />
                  </Avatar>
                  <Typography color="success.main">
                    You're within the allowed time. Would you like to start a
                    chat?
                  </Typography>
                </>
              ) : (
                <>
                  <Avatar sx={{ bgcolor: "#f44336", width: 28, height: 28 }}>
                    <ErrorOutline fontSize="small" />
                  </Avatar>
                  <Typography color="error">
                    You're outside the service hours. Please try again later.
                  </Typography>
                </>
              )}
            </Box>
            {withinTime && (
              <Box mt={2}>
                <Typography variant="body2" mb={1}>
                  Select an existing ticket or start a new chat:
                </Typography>
                <Select
                  value={selectedTicketId}
                  onChange={(e) => setSelectedTicketId(e.target.value)}
                  displayEmpty
                  fullWidth
                  size="small"
                  sx={{ backgroundColor: "#fff", borderRadius: 2 }}
                >
                  <MenuItem value="">Start New Chat</MenuItem>
                  {ticketList.map((ticket) => (
                    <MenuItem key={ticket.id} value={ticket.id}>
                      {`${ticket.id} ${ticket.subject}`}
                    </MenuItem>
                  ))}
                </Select>
                {/* ⚠️ Important Note to User */}
                <Typography
                  variant="caption"
                  color="warning.main"
                  mt={1}
                  display="block"
                  fontStyle="italic"
                >
                  * If you select a Ticket ID, you’ll enter the chat for that
                  ticket, which may already be closed. To start a fresh chat
                  session, leave this blank.
                </Typography>
              </Box>
            )}
          </DialogContent>

          <DialogActions sx={{ justifyContent: "space-between", px: 3, pb: 2 }}>
            <Button
              onClick={() => setOpenModal(false)}
              variant="outlined"
              color="secondary"
              sx={{ borderRadius: 2, textTransform: "none" }}
            >
              Cancel
            </Button>

            <Tooltip
              title={
                !withinTime ? "Available only between 10:30 AM - 6:30 PM" : ""
              }
            >
              <span>
                <Button
                  onClick={() => {
                    setOpenModal(false);
                    handleGoToChat();
                  }}
                  variant="contained"
                  color="primary"
                  disabled={!withinTime}
                  sx={{
                    textTransform: "none",
                    borderRadius: 2,
                    fontWeight: "bold",
                    px: 3,
                  }}
                >
                  Start Chat
                </Button>
              </span>
            </Tooltip>
          </DialogActions>
        </Dialog>
      </Container>
    </div>
  );
};

export default CreateNewChatSession;
